var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNotLogin)?_c('div',{staticClass:"d-flex mb-0 mr-25"},[_c('b-link',{staticClass:"alert-link text-info",attrs:{"to":{ name: 'auth-login' }}},[_c('span',[_vm._v("LOGIN")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }